import { setHostLocale } from "@/i18n/languages";
import type { useSessionStore } from "@/stores/session";
import type { NavBarItem, UserOrganisation } from "@/tenant/types";

const PREVIEW_KEY = "metaship:dev:previewSession";

/** Local-only chrome preview (`?previewSession=1` on a dev host). Lets us
 *  screenshot the host language picker + Boer NAV-DRILL labels without Auth0.
 *  Remembered for the tab — a home-path redirect strips the query. */
export function shouldApplyPreviewSession(search: string, isDev: boolean): boolean {
  if (!isDev) return false;
  if (new URLSearchParams(search).get("previewSession") === "1") {
    try {
      sessionStorage.setItem(PREVIEW_KEY, "1");
    } catch {
      /* ignore */
    }
    return true;
  }
  try {
    return sessionStorage.getItem(PREVIEW_KEY) === "1";
  } catch {
    return false;
  }
}

export function applyPreviewSession(session: ReturnType<typeof useSessionStore>): void {
  const org: UserOrganisation = {
    id: 1,
    name: "Klipfontein",
    token: "preview",
    accountStatus: "active",
    icon: null,
    logo: null,
  };
  const navItems: NavBarItem[] = [
    {
      name: "Boer",
      icon: "agriculture",
      route: "/boer",
      items: [
        { name: "Get Started", icon: "waving_hand", route: "/boer", section: "start" },
        { name: "Dashboard", icon: "dashboard", route: "/boer?section=dashboard", section: "dashboard" },
        { name: "Farms & Blocks", icon: "agriculture", route: "/boer?section=farms", section: "farms" },
        { name: "Atlas", icon: "map", route: "/boer?section=atlas", section: "atlas" },
        { name: "Harvest", icon: "agriculture", route: "/boer?section=harvest", section: "harvest" },
        { name: "Spray", icon: "water_drop", route: "/boer?section=spray", section: "spray" },
        { name: "Compliance", icon: "verified_user", route: "/boer?section=locker", section: "locker" },
        { name: "Settings", icon: "settings", route: "/boer?section=settings", section: "settings" },
      ],
    },
  ];
  session.status = "ready";
  session.user = {
    id: 1,
    email: "preview@theboer.co.za",
    firstname: "Jan",
    surname: "Boer",
    emailAddress: "preview@theboer.co.za",
  };
  session.currentOrg = org;
  session.accessibleOrgs = [org];
  session.navItems = navItems;
  window.MetaShipGlobalState?.updateState({
    user: session.user,
    currentOrg: org,
    organisations: [org],
    locale: "af",
  });
  setHostLocale("af");
}
